<div class="registro-bar" *ngIf="this.setionAmbulancia || this.setionEnfermeria || this.setionRehabilitacion">
  <div class="registro-title text-bold">
    Información adicional de servicios
  </div>

  <div class="button-expand" *ngIf="!expanded">
    <i class="fas fa-chevron-down" (click)="expanded = true"></i>
  </div>
  <div class="button-expand" *ngIf="expanded">
    <i class="fas fa-chevron-up" (click)="expanded = false"></i>
  </div>
</div>

<div class="container-registro" *ngIf="expanded">
  <div class="form-registro">
    <form [formGroup]="formRegistroSection">
      <div class="registro-item" *ngIf="setionEnfermeria">
        <h3>REGISTRO DE ENFERMERÍA</h3>
        <div class="input-info-group">
          <div class="input">
            <label>Días solicitados (*)</label>
            <input
              type="text"
              formControlName="diasEnfermeria"
              mask="separator.2"
              thousandSeparator="."
              decimalMarker=","
            />
            <small
              *ngIf="fRegistroSection.diasEnfermeria.invalid && fRegistroSection.diasEnfermeria.touched"
              class="text-danger"
            >
              Dato no válido
            </small>
          </div>
          <div class="info">
            <span><strong>{{diasEnfermeriaMax}}</strong> Máx</span>
            <span><strong>{{diasEnfermeriaAcomulados}}</strong> Días acumulados</span>
          </div>
        </div>
      </div>

      <div class="registro-item" *ngIf="setionRehabilitacion">
        <h3>SESIONES DE REHABILITACIÓN</h3>
        <div class="input-info-group">
          <div class="input">
            <label>Sesiones solicitadas (*)</label>
            <input
              type="text"
              formControlName="sesionesRehabilitacion"
              mask="separator.0"
              thousandSeparator="."
            />
            <small
              *ngIf="fRegistroSection.sesionesRehabilitacion.invalid && fRegistroSection.sesionesRehabilitacion.touched"
              class="text-danger"
            >
              Dato no válido
            </small>
          </div>
          <div class="info">
            <span><strong>{{sesionesRehabilitacionMax}}</strong> Máx</span>
            <span><strong>{{sesionesRehabilitacionAcomulados}}</strong> Sesiones acumuladas</span>
          </div>
        </div>
      </div>

      <div class="registro-item" *ngIf="setionAmbulancia">
        <h3>SERVICIO DE AMBULANCIA</h3>
        <div class="input-info-group">
          <div class="input">
            <label>Servicios solicitados (*)</label>
            <input
              type="text"
              formControlName="serviciosAmbulancia"
              mask="separator.0"
              thousandSeparator="."
            />
            <small
              *ngIf="fRegistroSection.serviciosAmbulancia.invalid && fRegistroSection.serviciosAmbulancia.touched"
              class="text-danger"
            >
              Dato no válido
            </small>
          </div>
          <div class="info">
            <span><strong>{{serviciosAmbulanciaMax}}</strong> Máx</span>
            <span><strong>{{serviciosAmbulanciaAcomulados}}</strong> Servicios acumulados</span>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="button-save">
    <button
      class="fas fa-save"
      [disabled]="formRegistroSection.invalid"
      (click)="saveRegistroSection()"
    >
    </button>
  </div>
</div>

<ngx-smart-modal
  #saveServiciosCobertura
  identifier="saveServiciosCobertura"
  [closable]="false"
  [dismissable]="false"
  [customClass]="'nsm-centered modal-reject-contrac'"
  class="text-center"
>
  <div class="modal-icon-primary">
    <i class="fas fa-check-circle"></i>
  </div>
  <div class="container-modal">
    <div class="mb-3"></div>
    <p>
      {{ msgModal }}
    </p>
  </div>
  <div>
    <button (click)="confirmSave()" class="btn btn-primary mt-3">
      aceptar
    </button>
  </div>
</ngx-smart-modal>

<ngx-smart-modal
  #errorModal
  identifier="errorModal"
  [customClass]="'nsm-centered'"
  class="text-center"
  [dismissable]="false"
  [closable]="false"
>
  <div class="errorModal">{{ errorMsg }}</div>
  <button
    style="margin-top: 20px"
    class="btn btn-primary"
    (click)="closeModal('errorModal')"
  >
    ACEPTAR
  </button>
</ngx-smart-modal>
